import { KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DeviceBoardService } from "./device-board.service";
import { Router } from "@angular/router";
var DeviceBoardComponent = (function () {
    function DeviceBoardComponent(deviceBoardService, differs, toastr, vcr, router) {
        this.deviceBoardService = deviceBoardService;
        this.differs = differs;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.toastr.setRootViewContainerRef(vcr);
        this.differ = this.differs.find({}).create();
    }
    DeviceBoardComponent.prototype.ngOnInit = function () {
        this.title = "Device Board";
        this.filterParams = {
            size: 10,
            page: 0
        };
    };
    DeviceBoardComponent.prototype.ngDoCheck = function () {
        var change = this.differ.diff(this.filterParams);
        if (change) {
            if (this.filterParams.page < 0) {
                this.filterParams.page = 0;
                return;
            }
            else if (this.filterParams.page > this.totalPage - 1) {
                this.filterParams.page = this.totalPage - 1;
                return;
            }
            this.getDeviceBoardList();
        }
    };
    DeviceBoardComponent.prototype.getDeviceBoardList = function () {
        var _this = this;
        this.isLoading = true;
        this.deviceBoardService.getDeviceBoardList(this.filterParams)
            .then(function (res) {
            if (res.status === 1) {
                _this.deviceBoardList = res.data.dataList;
                _this.totalElements = res.data.totalElements;
                _this.initPaginate();
                _this.isLoading = false;
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
        })
            .catch(function (err) { return console.log(err); });
    };
    //init paging 
    DeviceBoardComponent.prototype.initPaginate = function () {
        this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
        var arrPagingNumber = [];
        for (var i = 0; i < this.totalPage; i++) {
            arrPagingNumber.push(i);
        }
        return arrPagingNumber;
    };
    DeviceBoardComponent.prototype.editdeviceBoard = function (deviceBoard) {
        this.deviceBoardInfo = deviceBoard;
        $('#myModal').modal('show');
    };
    DeviceBoardComponent.prototype.onSubmit = function (formDeviceBoard) {
        var _this = this;
        this.deviceBoardService.editDeviceBoard(formDeviceBoard.value)
            .then(function (res) {
            console.log(res);
            if (res.status === 1) {
                _this.getDeviceBoardList();
                $('#myModal').modal('hide');
            }
            else {
                _this.toastr.error(res.message, "ERROR!");
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
        }).catch(function (err) { return console.log(err); });
    };
    return DeviceBoardComponent;
}());
export { DeviceBoardComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/device-board/device-board.component.ts.pre-build-optimizer.js